<template>
  <el-dialog
    title="精彩纵横云采购平台隐私策略"
    :visible.sync="showDialog"
    width="70rem"
    :close-on-click-modal="false"
    :append-to-body="true"
    :before-close="closeDialog"
  >
    <p>我们非常重视您的隐私，保护用户隐私是精彩纵横的重点原则，以下即是当您浏览、使用精彩纵横时，我们的隐私策略。该策略作为《用户协议》的一部分，在您选择使用我们提供的服务时，必须被全部接受。以下策略可能会因将来提供更多的新服务而有所改动。相关条款一旦被修改，我们会在重要页面上提醒、说明，并立即生效。如果您不同意被修改的隐私策略，可主动取消已获得的服务；如果您继续使用服务，则视为接受策略的修改。故建议您定期查阅。</p>
    <p>一、用户信息</p>
    <p>1、精彩纵横将对您所提供的资料进行严格的管理及保护，通过技术手段、提供隐私保护服务功能、强化内部管理等办法充分保护用户的个人资料安全。精彩纵横保证不对外公开或向第三方提供用户注册的资料，及用户在使用服务时存储的非公开内容，但下列情况除外：</p>
    <p>（1）事先获得您的明确授权；</p>
    <p>（2）根据有关的法律法规要求；</p>
    <p>（3）按照相关司法机构或政府主管部门的要求；</p>
    <p>（4）只有透露你的个人资料，才能提供你所要求的产品的和服务；</p>
    <p>（5）因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用；</p>
    <p>（6）由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人资料泄露；</p>
    <p>2、账户信息我们主要收集您在精彩纵横上注册为会员后的账户信息，包括账户内需要提交的公司名称、地址、联系人、电话、传真、电子邮箱等公司、产品和招标采购信息（您可通过登录名和密码修改以上部分内容）。收集这些信息的目的是为了执行精彩纵横的服务条款，为您提供我们承诺的服务，或解决可能存在的问题。</p>
    <p>3、隐含信息我们还收集可供精彩纵横及其商业伙伴参考或使用的隐含信息。此类信息来源于“用户访问记录”，包括但不限于“Cookies”（访问精彩纵横要求您需要接受“Cookies”）、“IP地址”、浏览过的网页或其他数字识别，以及非会员用户在使用精彩纵横部分服务时被要求提交的信息。我们对这些信息进行收集，是为了使我们的网站界面对您更友好，并通过综合统计与市场分析，更有针对性的为您提供有效服务，同时也是防止精彩纵横受到恶意攻击的必要措施。</p>
    <p>4、其他信息为了能够向您提供更全面、专业、细致的服务，精彩纵横在某些领域会通过与第三方合作的方式建立服务。在您选择应用第三方的服务时，您可能需要向该第三方提供某些信息，如向在线支付机构提供银行卡信息。一旦您使用了第三方合作伙伴的服务或产品，精彩纵横隐私策略将不再生效，我们建议您查看该合作伙伴网站的隐私策略，并了解该合作伙伴对于收集、使用、泄露您的个人信息的规定。</p>
    <p>5、我们不会将您在访问和使用精彩纵横网站以及相关服务时提交的信息如姓名、地址、电子邮件地址以及电话号码等透露或公开给第三方个人或企业。同时,如上所述,我们可能会将这些信息的统计结果与我们的合作伙伴共享。</p>
    <p>二、隐私保护原则的变动</p>
    <p>如果我们需要改变隐私策略,我们会把相关的改动在相关页面发布,以便您能随时了解我们会收集什么信息,我们可能会如何使用这些信息以及我们是否会把此信息透露给第三方。</p>
  </el-dialog>
</template>

<script>
export default {
  name: 'PrivacyPolicy',

  model: {
    prop: 'showDialog',
    event: 'change'
  },

  props: {
    showDialog: {
      type: Boolean,
      required: false
    }
  },

  methods: {
    closeDialog() {
      this.$emit('change', false)
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  text-indent: 2em;
  text-align: left;
  margin: 0;
  line-height: 1.8;
}
</style>